import App from '@/app.vue';

import '@/config/inversify.config';

import { ROUTER } from '@/router/router';

import { STORE } from '@/store/store';

import { initApp, initWorker } from '@empathybroker/playboard-core/dist/src/utils/init';

import Vue from 'vue';

initApp({ environment: process.env.VUE_APP_ENV });
initWorker();

new Vue({
  router: ROUTER,
  store: STORE,
  render: (h) => h(App)
}).$mount('#app');
